// GA4 / GTM event tracking helper
// All conversion events funnel through here so they can be marked as key events in GA4.

type EventPayload = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export const trackEvent = (name: string, payload: EventPayload = {}): void => {
  if (typeof window === 'undefined') return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...payload });
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
    }
  } catch {
    /* ignore analytics errors */
  }
};

// Named helpers for the required key events
export const trackPhoneClick = (source?: string) =>
  trackEvent('phone_click', { source, phone: '9363200763' });

export const trackEmailClick = (source?: string) =>
  trackEvent('email_click', { source, email: 'thegrassdepotllc@gmail.com' });

export const trackQuoteButtonClick = (source?: string) =>
  trackEvent('quote_button_click', { source });

export const trackQuoteFormSubmit = (payload?: EventPayload) =>
  trackEvent('quote_form_submit', payload);

export const trackContactFormSubmit = (payload?: EventPayload) =>
  trackEvent('contact_submit', payload);

export const trackCalculatorUse = (payload?: EventPayload) =>
  trackEvent('calculator_use', payload);

export const trackMapClick = (source?: string) =>
  trackEvent('map_click', { source });

export const trackInternalLink = (source?: string, target?: string) =>
  trackEvent('internal_link_click', { source, target });
